import { Box } from '@wix/design-system';
import { Tag } from '@wix/wix-ui-icons-common/lazy';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { BaseVoucherBanner } from './VoucherBanner';
const TLD_LIST_BANNER_KEY = 'domains_search_gate.tld_list.banner.promo_code';
export const TldListVoucherBanner = () => {
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  return /*#__PURE__*/React.createElement(BaseVoucherBanner, {
    icon: /*#__PURE__*/React.createElement(Box, {
      alignSelf: "flex-start"
    }, /*#__PURE__*/React.createElement(Tag, {
      size: "24px"
    })),
    content: t(TLD_LIST_BANNER_KEY)
  });
};
//# sourceMappingURL=TldListVoucherBanner.js.map